import {
  Avatar,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { t } from "i18next";
import moment from "moment";
import PropTypes from "prop-types";
import appcolors from "../../constants/Colors";
import IOSSwitch from "../IsoSwitch";

function DashboardStatus({ userImage, showSwitch = false }) {
  return (
    <Grid container mt={3}>
      <Grid item xs={12} md={4}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Stack direction={"row"} gap={2} alignItems={"center"}>
            <Avatar
              sx={{ height: { md: "55px" }, width: { md: "55px" } }}
              src={
                userImage ||
                "https://sirldigital.com/uploads/209058670-dumy-women-image.jpeg"
              }
            />
            <Stack>
              <Typography
                variant="h3"
                fontSize={"1rem"}
                fontWeight={600}
                color={appcolors.gunmetal}
              >
                {t("dashboard")}
              </Typography>
              <Typography
                variant="body2"
                fontSize={"0.75rem"}
                color={appcolors.crayolaGrey}
              >
                {t("today")} : {moment(new Date()).format("DD/MM/YYYY")}
              </Typography>
            </Stack>
          </Stack>
          {showSwitch && (
            <FormGroup>
              <FormControlLabel
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "0.857rem",
                    fontWeight: 600,
                    color: "#5F5F5F",
                  },
                }}
                control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
                label={t("live")}
              />
            </FormGroup>
          )}
        </Stack>
      </Grid>
    </Grid>
  );
}

DashboardStatus.propTypes = {
  showSwitch: PropTypes.bool,
};

export default DashboardStatus;
